import axios from 'axios';

const getInitialState = function () {
  return {
    languages: [],
    myPreferredLanguages: [],
  };
};

export default {
  namespaced: true,

  state: getInitialState(),

  getters: {
    /**
     * Returns a list of all languages, but each item also includes a flag to indicate whether the user has selected it or not.
     *
     * {
     *  language_cd: 'en',
     *  selected: true  // TRUE indicates the user has selected this language
     * }
     */
    allLanguagesWithUserPreferenceIncluded: function (state) {
      let priorityList = [
        'English', 'Spanish, Castilian', 'Portuguese', 'Hindi', 'French', 
        'Japanese', 'Italian', 'Arabic', 'Dutch, Flemish', 'Gujarati'
      ];

      let result = [];

      // loop over all languages and assign selected attribute:
      for (let lang of state.languages) {
        lang.selected = Boolean(state.myPreferredLanguages.find(l => l.id == lang.id));
        result.push(lang);
      }
  
      // sort the result array to prioritize the languages in the priority list
      result.sort((a, b) => {
        let aIndex = priorityList.indexOf(a.language);
        let bIndex = priorityList.indexOf(b.language);

        if (aIndex !== -1 && bIndex === -1) return -1;
        if (aIndex === -1 && bIndex !== -1) return 1;
        if (aIndex !== -1 && bIndex !== -1) return aIndex - bIndex;

        // if both languages are not in the priority list, keep their original order
        return 0;
      });

      return result;
    },
    allLanguages: function (state) {
      return state.languages;
    },
  },

  mutations: {
    SET_LANGUAGES: function (state, languages) {
      state.languages = languages;
    },
    SET_MY_PREFERRED_LANGUAGES: function (state, languages) {
      state.myPreferredLanguages = languages;
    },
    ADD_TO_MY_PREFERRED_LANGUAGES: function (state, newLanguage) {
      state.myPreferredLanguages.push(newLanguage);
    },
    REMOVE_FROM_MY_PREFERRED_LANGUAGES: function (state, language) {
      state.myPreferredLanguages = state.myPreferredLanguages.filter(function (item) {
        return item.id != language.id;
      });
    },
    RESET_STATE: function (state) {
      Object.assign(state, getInitialState());
    },
  },

  actions: {
    loadLanguages: function ({ commit, state }, reload = false) {
      if (!reload && state.languages.length > 0) return state.languages;

      return axios.get('/languages').then(resp => {
        commit('SET_LANGUAGES', resp.data);
        return resp.data;
      });
    },
    loadMyPreferredLanguages: function ({ commit, state }, reload = false) {
      if (!reload && state.myPreferredLanguages.length > 0) return state.myPreferredLanguages;

      return axios.get('/auth/my-feed-languages').then(resp => {
        commit('SET_MY_PREFERRED_LANGUAGES', resp.data);
        return resp.data;
      });
    },
  },
};